export const MAX_LIST_SIZE = 10;

export const SELECT_REVIEWER_EVENT = 'user_selects_reviewer_from_mr_sidebar';
export const SEARCH_SELECT_REVIEWER_EVENT = 'user_selects_reviewer_from_mr_sidebar_after_search';
export const REQUEST_REVIEW_SIMPLE = 'user_requests_review_from_mr_simple_sidebar';
